import React, { useState, useEffect } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { logoutUser } from "../../firebase/authService";

const AdminLayout = ({ children, activePage, setActivePage, user }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true); // ← DEFAULT TRUE

  // Desktop par sidebar hamesha open
  // Mobile par toggle kar sakte ho
  useEffect(() => {
    const checkWidth = () => {
      if (window.innerWidth > 1024) {
        setSidebarOpen(true);
      }
    };

    // Page load par check karo
    checkWidth();

    // Window resize par bhi check karo
    window.addEventListener("resize", checkWidth);
    return () => window.removeEventListener("resize", checkWidth);
  }, []);

  const handleLogout = async () => {
    if (window.confirm("Are you sure you want to logout?")) {
      await logoutUser();
    }
  };

  return (
    <div className="admin-layout">
      <AdminSidebar
        activePage={activePage}
        setActivePage={setActivePage}
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
        user={user}
      />

      <div className="admin-main">
        <AdminHeader
          onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
          activePage={activePage}
          user={user}
          onLogout={handleLogout}
        />

        <div className="admin-content">{children}</div>

        <div className="admin-footer">
          <p>
            © 2026{" "}
            <span className="footer-highlight">SDtech Solutions</span>{" "}
            Admin Panel. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;